<template>
  <tr>
    <td>
      <router-link :to="`/orders/${label.order_id}?label=${label.id}`">
        <button class="btn btn-app btn-info"><i class="fa fa-reply"></i>{{ 'order' | translate }}</button>
      </router-link>
    </td>
    <td class="small">
      {{ label.created_at | orderDate }}<br>
      <span class="text-muted"><i class="fa fa-clock-o mr-5"></i>{{ label.created_at | orderDate(true) }}</span>
    </td>
    <td>
      <div v-for="message in messages" @click="$emit('payload', label.payload)" class="alert alert-danger"
           style="margin-bottom: 5px !important">
        <span><i class="fa fa-exclamation-triangle mr-5"></i>{{ message }}</span>
      </div>
    </td>
    <td>{{ label.status }}</td>
    <td class="text-right">
      <select class="form-control" @change="changeParcelOptions()" v-model="selectedParcelOption">
        <option class="normal" :selected="selectedParcelOption" v-for="option in parcelOptions" :value="option.id">
          ({{ option.carrier }}) {{ option.width }} cm -
          {{ option.height }} cm - {{ option.length }} cm - {{ option.weight }} kg
        </option>
      </select>
    </td>
    <td class="text-right">
      <div class="button-group">
        <button class="btn btn-default no-margin btn-lg" :disabled="disabled" @click="retry(label)" data-toggle="tooltip" title="Erzeugung erneut versuchen">
          <i :class="['fa fa-refresh', disabled ? 'fa-spin' : '' ]"></i>
        </button>
        <button @click="correct(label)" :disabled="disabled" class="btn btn-default no-margin btn-lg" data-toggle="tooltip" title="Adresse bearbeiten / ändern">
          <i class="fa fa-address-book"></i>
        </button>
        <button class="btn btn-default no-margin btn-lg" @click="handleGoToLabelsClick('home_address' ,label)" data-toggle="tooltip" title="Neues Hausadressen Label">
          <i class="fa fa-home"></i>
        </button>
        <button class="btn btn-default no-margin btn-lg" @click="handleGoToLabelsClick('packstation', label)" data-toggle="tooltip" title="Neues Packstation Label">
          <i class="fa fa-map-marker"></i>
        </button>
      </div>
    </td>
  </tr>
</template>
<script>
export default {
  props: ['label', 'index', 'messages', 'parcelOptions'],
  data() {
    return {
      disabled: false,
      selectedParcelOption: this.label.parcel_option_id,
      originOption: this.label.parcel_option_id,
      parcelOptionChanged: false,
    }
  },
  methods: {
    handleGoToLabelsClick(addressType, label) {
      this.$router.push({
        name: 'labels',
        params: {
          label: label,
          addressType: addressType
        }
      })
    },
    changeParcelOptions() {
      this.parcelOptionChanged = this.selectedParcelOption !== this.originOption;
    },
    retry(label) {
      this.disabled = true
      let data={};
      if(this.parcelOptionChanged===true){
        data={parcel_option:this.selectedParcelOption};
      }
      API.put(`monitoring/labels/failed/${label.id}`,data)
        .then(response => {
          if (response.status === 304) {
            this.update('Sorry! the label is already being processed. Please wait and retry later if necessary')
          } else {
            this.$store.commit('pushAlert', {
              dismiss: 4,
              type: 'success',
              message: 'Das Label wird erneut bearbeitet',
              icon: 'fa fa-check',
              show: true
            })
            this.disabled = false
            this.$emit('remove', label)
          }
        })
        .catch(error => {
          this.$store.commit('pushAlert', {dismiss: 4, type: 'danger', message: error, icon: 'fa fa-ban', show: true})
        })
    },
    correct(label) {
      this.disabled = true
      API.get(`orders/${label.order_id}/customer`)
        .then(response => {
          this.$emit('correct', {data: response.data, id: label.order_id})
          this.disabled = false
        })
    }
  },
  watch: {
    label() {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/TableRows/LabelRow.vue